import {
  FieldType,
  FieldTypeType,
  OptionType,
} from "../../../services/helpers/types";
import { TFunction } from "i18next";

export const getLanguageField = (t: TFunction) => {
  const LANGUAGE_OPTIONS: OptionType[] = [
    {
      name: t("sk"),
      value: "sk",
      position: 1,
      optionID: 0,
      fieldID: 4,
    },
    {
      name: t("cs"),
      value: "cs",
      position: 2,
      optionID: 1,
      fieldID: 4,
    },
    {
      name: t("en"),
      value: "en",
      position: 3,
      optionID: 2,
      fieldID: 4,
    },
  ];
  const LANGUAGE_FIELD: FieldType = {
    fieldID: 5,
    name: "SelectField",
    position: 5,
    type: FieldTypeType.Select,
    noteOption: false,
    defaultValue: "sk",
    options: LANGUAGE_OPTIONS,
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return LANGUAGE_FIELD;
};

export const getFontSizeField = (t: TFunction) => {
  const FONTSIZE_OPTIONS: OptionType[] = [
    {
      name: t("normal"),
      value: "normal",
      position: 1,
      optionID: 0,
      fieldID: 4,
    },
    {
      name: t("large"),
      value: "large",
      position: 2,
      optionID: 1,
      fieldID: 4,
    },
  ];

  const FONTSIZE_FIELD: FieldType = {
    fieldID: 5,
    name: "SelectField",
    position: 5,
    type: FieldTypeType.Select,
    noteOption: false,
    defaultValue: "normal",
    options: FONTSIZE_OPTIONS,
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return FONTSIZE_FIELD;
};

export const getThemeField = (t: TFunction) => {
  const THEME_OPTIONS: OptionType[] = [
    {
      name: t("light"),
      value: "light",
      position: 1,
      optionID: 0,
      fieldID: 4,
    },
    {
      name: t("dark"),
      value: "dark",
      position: 2,
      optionID: 1,
      fieldID: 4,
    },
  ];

  const THEME_FIELD: FieldType = {
    fieldID: 5,
    name: "SelectField",
    position: 5,
    type: FieldTypeType.Select,
    noteOption: false,
    defaultValue: "light",
    options: THEME_OPTIONS,
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return THEME_FIELD;
};

export const getDoctorsTypeField = (t: TFunction) => {
  const DOCTOR_TYPE_OPTIONS: OptionType[] = [
    {
      name: `${t("generalDoctor")} - SK`,
      value: "vseobecny",
      position: 1,
      optionID: 0,
      fieldID: 4,
    },
    {
      name: `${t("generalDoctor")} - CZ`,
      value: "vseobecnyCZ",
      position: 2,
      optionID: 1,
      fieldID: 4,
    },
    {
      name: `${t("pediatric")}`,
      value: "pediatria",
      position: 3,
      optionID: 2,
      fieldID: 4,
    },
  ];
  const DOCTOR_TYPE_FIELD: FieldType = {
    fieldID: 5,
    name: "SelectField",
    position: 5,
    type: FieldTypeType.Select,
    noteOption: false,
    defaultValue: "vseobecny",
    options: DOCTOR_TYPE_OPTIONS,
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return DOCTOR_TYPE_FIELD;
};
